import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";

function Try5() {
  document.title = "HR School-Single Certificate";

  // const conponentPDF = useRef();
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };
  const [usercertificate5, setusercertificate5] = useState([]);

  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname5")}`)
      .on("value", (sna) => {
        setusercertificate5([sna.val()]);
      });
  }, []);
  // const generatePDF = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  return (
    <div>
      <Header />
      <div>
        {usercertificate5.map((datas4) => {
          return (
            <>
              <div id="certificatetemp5" ref={domEl} style={{textTransform:"uppercase"}}>
                <center style={{ padding: "60px" }}>
                  {" "}
                  <br />
                  <br />
                  <h1>HR SCHOOL</h1>
                  <hr />
                  <h3>CERTIFICATE OF COMPLETION</h3>
                  <br />
                  <h2> CERTIFIED {datas4.Field} SPECIALIST</h2>
                  <br />
                  <p>THIS IS TO CERTIFY THAT</p>
                  <p className="temp5name">
                    NAME :- {datas4.Gender} {datas4.Name}
                  </p>
                  <p className="temp5name">FATHER NAME :- {datas4.Father}</p>
                  <p className="temp5name">
                    COURSE DURATION :- {datas4.Course} MONTHS
                  </p>
                  <p className="temp5name">
                    COURSE NAME :- {datas4.Coursename}
                  </p>
                  <div>
                    <div style={{ fontWeight: "bold" }}>
                      WITH SCORE OF {datas4.grade}
                    </div>{" "}
                    <br />
                    <div style={{ fontWeight: "bold" }}>Dated</div> <br />
                    <br />
                  </div>
                  <div>
                    START DATE :- {datas4.startdate}/{datas4.startmonth}/
                    {datas4.startyear}
                  </div>
                  <br />
                  <div>
                    END DATE :-{datas4.enddate}/{datas4.endmonth}/
                    {datas4.endyear}
                  </div>{" "}
                  <br />
                  <div>www.hrschool.com</div>
                </center>
              </div>
            </>
          );
        })}
      </div>
      <center>
        {" "}
        <br />
        {/* <button onClick={() => generatePDF()}>Convert In PDF</button> */}
        <button onClick={downloadImage} style={{ color: "black" }}>
          Download Image
        </button>
      </center>
    </div>
  );
}

export default Try5;
